import { defineComponent as _defineComponent } from 'vue'
import { IListItem, IListItemType } from "@/components-UI/list/types";
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import ListItemCode from "@/components-UI/list/items/ListItemCode.vue";
import ListItemDate from "@/components-UI/list/items/ListItemDate.vue";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import ListItemRoute from "@/components-UI/list/items/ListItemRoute.vue";
import ListItemNumber from "@/components-UI/list/items/ListItemNumber.vue";
import ListItemBoolean from "@/components-UI/list/items/ListItemBoolean.vue";

interface Props {
    item?: Record<string, any>
    list: IListItem[],
    extraTitle?: string,
    customClass?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseListV2',
  props: {
    item: null,
    list: null,
    extraTitle: null,
    customClass: null
  },
  setup(__props: any) {

const props = __props as {
    item?: Record<string, any>
    list: IListItem[],
    extraTitle?: string,
    customClass?: string,
}



const itemsMap: Record<IListItemType, any> = {
    text: ListItemText,
    code: ListItemCode,
    date: ListItemDate,
    route: ListItemRoute,
    number: ListItemNumber,
    boolean: ListItemBoolean,
};

return { __sfc: true,props, itemsMap, BaseQuestionMarkTooltip }
}

})